import React, { useEffect, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const links = [
  { to: '/', label: 'Home', end: true },
  { to: '/about', label: 'About' },
  { to: '/transform', label: 'Transform' },
  { to: '/timetable', label: 'Timetable' },
  { to: '/location', label: 'Location' },
  { to: '/contact', label: 'Contact' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header className={`sticky top-0 z-40 transition-all duration-300 ${scrolled ? 'bg-black/85 backdrop-blur-md border-b border-white/5' : 'bg-black/40 backdrop-blur-sm'}`}>
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="w-11 h-11 rounded-md overflow-hidden bg-white flex items-center justify-center shadow-sm group-hover:shadow-md transition-shadow">
            <img
              src="https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/4iwss1im_ST-fitness-logo-colour.webp"
              alt="ST"
              className="w-full h-full object-cover"
              style={{ objectPosition: 'center top', transform: 'scale(1.85)', transformOrigin: 'center 22%' }}
            />
          </div>
          <div className="leading-none">
            <div className="font-display text-lg md:text-xl tracking-wide text-white">SAM<span className="text-brand">.</span>TURNER</div>
            <div className="text-[10px] tracking-[0.25em] text-white/60 uppercase mt-1">Health & Fitness · Irlam</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) => `nav-link text-[13px] font-semibold tracking-[0.18em] uppercase text-white/85 hover:text-white ${isActive ? 'active text-white' : ''}`}
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact">
            <Button className="brand-gradient text-white font-semibold tracking-wider uppercase text-xs px-5 py-5 rounded-none hover:opacity-95 glow-brand">
              Start Now
            </Button>
          </Link>
        </nav>

        <button className="md:hidden text-white" aria-label="Toggle menu" onClick={() => setOpen((v) => !v)}>
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`md:hidden overflow-hidden transition-[max-height] duration-300 ${open ? 'max-h-96' : 'max-h-0'}`}>
        <div className="px-5 pb-5 pt-2 flex flex-col gap-3 bg-black/95 border-t border-white/5">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => `py-2 text-sm font-semibold tracking-[0.18em] uppercase ${isActive ? 'text-brand' : 'text-white/85'}`}>
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact">
            <Button className="brand-gradient text-white w-full uppercase tracking-wider text-xs rounded-none py-5">Start Now</Button>
          </Link>
        </div>
      </div>
    </header>
  );
}
